import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-51dc57b1"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "mb10 flex-v-center"
};
var _hoisted_2 = {
  key: 0,
  class: "nav-box-inCloud_redirect",
  href: '/console'
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = {
  class: "flex-m-between"
};
var _hoisted_6 = {
  key: 0,
  class: "info-alert mt10"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "el-icon-info mr5"
  }, null, -1);
});

var _hoisted_8 = {
  class: "auth-main-box"
};
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { ref, onMounted, reactive, computed, watch } from 'vue';
import AuthService from '@/api/auth';
import CompanyService from '@/api/company';
import { setStoreState } from '@/store/utils';
import { cloneDeep } from 'lodash';
import { SIMPLIFY_AUTHORITY_NAV_LIST, COMMON_AUTHORITY_NAV_LIST } from '@/config/auth';
export default /*#__PURE__*/_defineComponent({
  props: {
    searchParams: {
      type: Object,
      default: function _default() {
        return {
          appKey: ''
        };
      }
    },
    titleText: String
  },
  emits: ['updateSearchParams'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var inMicroApp = ref(window.__MICRO_APP_ENVIRONMENT__);
    var enableBatchOperate = window.AppConfig.authority.enableBatchOperate; // 声明 props，defineProps 接收与 props 选项相同的值

    var router = useRouter();
    var route = useRoute();
    var store = useStore();
    var menuList = reactive([]);
    var allNavList = reactive(enableBatchOperate ? COMMON_AUTHORITY_NAV_LIST : SIMPLIFY_AUTHORITY_NAV_LIST); // computed

    var isAdmin = computed(function () {
      return store.state.user.userDetail.isAdmin;
    });
    var routeName = computed(function () {
      return route.name;
    });
    var authList = computed(function () {
      if (isAdmin.value) {
        return allNavList.filter(function (item) {
          return !['申请角色组权限', '查看空间成员'].includes(item.label);
        });
      }

      return allNavList.filter(function (item) {
        return !['角色组管理', '权限审批流程设置', '空间成员管理'].includes(item.label);
      });
    });
    var curPage = computed(function () {
      return authList.value.find(function (item) {
        return routeName.value.indexOf(item.value) > -1;
      }) || {};
    }); // 云上版本需要支持返回控制台

    var inCloud = ref(window.AppConfig.isCloudVersion); // methods

    var changeAppKey = function changeAppKey(key) {
      if (props.searchParams.appKey === key) return;
      emits('updateSearchParams', 'appKey', key);

      if (routeName.value === 'AuthDefault') {
        router.push({
          name: authList.value[1].value,
          params: {
            project: key
          }
        });
      } else if (['AuthRoleGroup', 'AuthRoleGroupFix'].includes(routeName.value)) {
        // 角色组不同平台id各自不一样，所以切换不能带id
        router.push({
          name: 'AuthRoleGroup',
          params: {
            project: key
          }
        });
      } else {
        router.push({
          name: routeName.value,
          params: {
            project: key
          }
        });
      }
    };

    var changeMenu = function changeMenu(value) {
      router.push({
        name: value,
        params: {
          project: props.searchParams.appKey
        }
      });
    };

    var isInMicroApp = window.__MICRO_APP_ENVIRONMENT__;

    var updateMenuList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(corporationId) {
        var _result$data, _result$data2, result, originalAppList, _window$microApp$getD, globalAPI;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return AuthService.getPlatformList({
                  appKey: props.searchParams.appKey || '',
                  corporationId: corporationId
                });

              case 3:
                result = _context.sent;

                if (((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.code) === 1 && (_result$data2 = result.data) !== null && _result$data2 !== void 0 && _result$data2.result) {
                  originalAppList = cloneDeep(result.data.result);

                  if (isInMicroApp) {
                    _window$microApp$getD = window.microApp.getData(), globalAPI = _window$microApp$getD.globalAPI;
                    originalAppList = originalAppList.filter(function (app) {
                      var _globalAPI$micro$getA, _globalAPI$micro$getA2;

                      var appNameForMicroApp = (_globalAPI$micro$getA = globalAPI.micro.getAppConfig(app.app_key)) === null || _globalAPI$micro$getA === void 0 ? void 0 : (_globalAPI$micro$getA2 = _globalAPI$micro$getA.sidebar) === null || _globalAPI$micro$getA2 === void 0 ? void 0 : _globalAPI$micro$getA2.appName;

                      if (appNameForMicroApp) {
                        app.app_name = appNameForMicroApp;
                        return true;
                      }

                      return false;
                    });
                  }

                  menuList.splice.apply(menuList, [0, menuList.length].concat(_toConsumableArray(originalAppList)));
                }

                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function updateMenuList(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    watch(function () {
      return store.state.company.detail.corporation_id;
    }, function (newVal) {
      updateMenuList(newVal);
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _yield$CompanyService, corporationId, detail;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(store.state.company.detail.corporation_id === '')) {
                _context2.next = 7;
                break;
              }

              _context2.next = 3;
              return CompanyService.getEnteredLastCorporation();

            case 3:
              _yield$CompanyService = _context2.sent;
              corporationId = _yield$CompanyService.data.result;
              detail = store.state.detail;
              setStoreState('company', 'detail', _objectSpread(_objectSpread({}, detail), {}, {
                corporation_id: corporationId
              }));

            case 7:
              updateMenuList(store.state.company.detail.corporation_id);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    return function (_ctx, _cache) {
      var _component_el_menu_item = _resolveComponent("el-menu-item");

      var _component_el_menu = _resolveComponent("el-menu");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: _normalizeClass(['nav-box', {
          'nav-box-inCloud': inCloud.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("b", {
        class: _normalizeClass([{
          'nav-box-inCloud_title': inCloud.value
        }])
      }, "权限中心", 2), inCloud.value ? (_openBlock(), _createElementBlock("a", _hoisted_2, "返回概览页")) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authList), function (item, i) {
        return _openBlock(), _createElementBlock(_Fragment, null, [!item.hide ? (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(['page', item.class, {
            active: item.selectedName && item.selectedName.includes(_unref(routeName))
          }])
        }, [item.value ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: function onClick($event) {
            return changeMenu(item.value);
          }
        }, _toDisplayString(item.label), 9, _hoisted_3)) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.label), 1))], 2)) : _createCommentVNode("", true)], 64);
      }), 256))], 2), _createElementVNode("div", {
        class: _normalizeClass(['auth-wrap', {
          'auth-wrap-inMicro': inMicroApp.value,
          'auth-wrap-inCloud': inCloud.value
        }])
      }, [_createElementVNode("div", _hoisted_5, [_unref(curPage).label || __props.titleText ? (_openBlock(), _createElementBlock("h2", {
        key: 0,
        class: _normalizeClass(['title', {
          'auth-wrap-inCloud_title': inCloud.value
        }])
      }, _toDisplayString(_unref(curPage).label || __props.titleText), 3)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "titleCon")]), _unref(curPage).desc ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createTextVNode(_toDisplayString(_unref(curPage).desc), 1)])) : _createCommentVNode("", true), _createVNode(_component_el_menu, {
        class: "menu-list",
        "default-active": __props.searchParams.appKey || 'tkdsee',
        ellipsis: false,
        mode: "horizontal",
        onSelect: changeAppKey
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), function (item, idx) {
            return _openBlock(), _createBlock(_component_el_menu_item, {
              index: item.app_key,
              key: idx
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.app_name), 1)];
              }),
              _: 2
            }, 1032, ["index"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["default-active"]), _createElementVNode("div", _hoisted_8, [_renderSlot(_ctx.$slots, "default")])], 2)]);
    };
  }
});